<div class="filter-container">
  <div class="filter-header">
    <div class="filter-title mt-1">
      {{ tableFilter().title }}
    </div>
    <lib-button [type]="ButtonType.tertiary" [size]="InputSize.small" (buttonClick)="resetClicked()" i18n>
      Reset
    </lib-button>
  </div>
  <div class="mt-3 d-flex flex-column gap-3">
    @for (filterOption of tableFilter().unsavedOptions; track $index) {
      <lib-radio-button
        class="me-auto"
        [size]="InputSize.small"
        [selected]="filterOption.isSelected?.() ?? false"
        (buttonClick)="radioOptionClicked(filterOption)">
        {{ filterOption.name }}
      </lib-radio-button>
    }
  </div>
</div>
